/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {FloatElement, Header, SubText, Body, MainText, UpperHeader} from './styles';

export default props => {
  return (
    <FloatElement>
      <Header>
        <UpperHeader>
          <MainText>{props.title}</MainText>
        </UpperHeader>
        <SubText>{props.subTitle}</SubText>
      </Header>
      <Body>{props.children}</Body>
    </FloatElement>
  );
};
